<template>
  <section>
    <Spinner v-if="isLoading" />
    <OrderError
      v-if="hasErrors"
      :error="getCurrentErrorMessage"
      :descr="getCurrentErrorDescr"
      :level="getCurrentErrorLevel"
    />
    <LogoHeader :shopCode="getShopCode" />
    <article class="bistro-weborders-body">
      <article v-if="getProducts.length > 0">
        <AdditionalsDialog
          :showDialog="hasToShowAdditionalDialog"
          :options="getAdditionals"
          :selectedOptions="selectedOptions"
          @dismiss="dismissAdditionalDialog()"
          @addProduct="addProductAdditionalDialog()"
        />
        <section class="">
          <div
            v-for="(prodByDept, index) in getProducts"
            :key="index"
            class="col-xs-3"
          >
            <h1 class="menu-name">{{ prodByDept.name }}</h1>

            <div
              v-for="(product, index) in prodByDept.products"
              :key="index"
              class="col-xs-3"
            >
              <ProductItem
                v-if="hasAdditionals(product) === false"
                :product="product"
                :quantity="getQuantity(product.sku)"
                @plusQuantity="plusQuantity(product)"
                @lessQuantity="lessQuantity(product.sku)"
                :showBandAid="true"
              />
              <ProductItemForAdditionals
                v-else
                :product="product"
                @click="showAdditionalsModal(product)"
                :showBandAid="true"
              />
            </div>
          </div>

          <br />
        </section>
      </article>

      <article v-else-if="loaded" class="menuError">
        <h4>No hay productos disponibles</h4>
      </article>
    </article>

    <Footer cartLink="SelfServiceCheckout" />
  </section>
</template>

<script>
import { db } from "../plugins/firebase";
import mobile_detection from "../mixins/mobile_detection";
import spinner_mixin from "../mixins/Spinner_Mixin";
import cart_mixin from "../mixins/Cart_Mixin";
import order_error_mixin from "../mixins/OrderError_Mixin";
import ProductItem from "../Components/ProductItem";
import ProductItemForAdditionals from "../Components/ProductItemForAdditionals";
import LogoHeader from "../Components/LogoHeader";
import Spinner from "../Components/Spinner";
import AdditionalsDialog from "../Components/AdditionalsDialog";
import Footer from "../Components/Footer";
import OrderError from "../Components/OrderError";
import { http } from "../axios";
import { baseUrl, mySelfUrl } from "../server";
import "../assets/site.css";

export default {
  mixins: [mobile_detection, spinner_mixin, order_error_mixin, cart_mixin],
  name: "SelfService",
  data() {
    return {
      // idList: -1,
      webOrderShopImageUrl: "",
      loaded: false
    };
  },
  mounted() {
    this.shopCode = this.$route.query.c;
    this.origin = this.$route.query.o;
    this.table = this.$route.query.t;

    if (this.table !== this.$store.getters.getTable) {
      this.$store.commit("SET_SELECTED_PRODUCTS", []);
    } else if (this.shopCode !== this.$store.getters.getSelfServiceShopCode) {
      this.$store.commit("SET_SELECTED_PRODUCTS", []);
    }

    this.validateCartExpiration()

    this.$store.commit("SET_SELF_SERVICE_SHOP_CODE", this.shopCode);
    this.$store.commit("SET_SELF_SERVICE_ORIGIN", this.origin);
    this.$store.commit("SET_SELF_SERVICE_PAYMENT_LINK", null);
    this.$store.commit("SET_SELF_SERVICE_TABLE", this.table);
    this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
    this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
    this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
    this.$store.commit("SET_CURRENT_ERROR_DESCR", null);

    this.getListByShops();
    this.getShopInfo();
  },
  watch: {
    "$route.params.search": {
      handler: function(search) {
        if (
          (this.$route.query.c !== this.shopCode && this.shopCode !== null) ||
          (this.$route.query.t !== this.table && this.table !== null) ||
          (this.$route.query.o !== this.origin && this.origin !== null)
        ) {
          const newUrl = `${mySelfUrl}/#${this.$route.fullPath}`;
          this.$router.go(newUrl);
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {
    getShopInfo() {
      // this.$store.commit("SET_IS_LOADING", true);
      // http
      //   .get(`${baseUrl}/api/ShopInfo?ShopCode=${this.shopCode}`)
      //   .then(response => {
      //     if (response.data.responseCode === 0) {
      //       if (response.data.isOpen === false) {
      //         this.showClosedShopDialog();
      //       }
      //     } else {
      //       alert(`${response.data.responseMessage}`);
      //     }
      //   })
      //   .catch(error => {
      //     console.log(error);
      //     alert("No pudimos obtener datos del comercio");
      //   });

      // this.$store.commit("SET_IS_LOADING", false);
    },
    showClosedShopDialog() {
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
      this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
      this.$store.commit(
        "SET_CURRENT_ERROR_MESSAGE",
        "El comercio esta cerrado! Lo sentimos!"
      );
      this.$store.commit(
        "SET_CURRENT_ERROR_DESCR",
        "Podés volver a pedir cuando esté abierto nuevamente. Gracias!"
      );
    },
    getListByShops() {
      const t = this;
      this.$store.commit("SET_IS_LOADING", true);
      db.ref("products/" + this.shopCode)
        .once("value")
        .then(function(snapshot) {
          var res = snapshot.val();
          if (res === null) {
            t.$store.commit(
              "SET_CURRENT_ERROR_MESSAGE",
              "Oops no pudimos entender eso"
            );
            t.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
            t.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
            t.$store.commit(
              "SET_CURRENT_ERROR_DESCR",
              "No podemos mostrarte la carta del local. Aún no fue generada la carta o la URL que ingresaste no es correcta. Por favor revisa y volvé a intentar"
            );
          } else if (res.idList != null) {
            t.idList = res.idList;
            t.webOrderShopImageUrl = res.webOrderShopImageUrl;
            t.refreshProductList(t.idList, t);
          }
          t.$store.commit("SET_IS_LOADING", false);
        });
    }
  },
  components: {
    ProductItem,
    AdditionalsDialog,
    ProductItemForAdditionals,
    LogoHeader,
    Spinner,
    Footer,
    OrderError
  }
};
</script>

<style scoped>
.menu-name {
  font-size: 2em;
}
h1,
h2 {
  font-weight: normal;
}
p {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 0em !important;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bwo-title-inline {
  display: inline;
}

.bwo-menu-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.item-content {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SelfService.vue